export const getMoodLabel = (score) => {
  if (!score || score <= 2) return 'Очень низко';
  if (score <= 4) return 'Низко';
  if (score <= 6) return 'Средне';
  if (score <= 8) return 'Хорошо';
  return 'Отлично';
};

export const getMoodColor = (score) => {
  if (!score || score <= 3) return '#ef4444';
  if (score <= 5) return '#f59e0b';
  if (score <= 7) return '#6366f1';
  return '#22c55e';
};
